module.exports = __webpack_public_path__ + "static/media/Office.0fad28f9.svg";